import React from 'react';
import { Modal } from 'antd';
import StoreDepartmentForm from './StoreDepartmentForm';

const StoreDepartmentModal = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
  title,
  stores = [],
}) => {
  return (
    <Modal
      title={title || 'Add Department'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <StoreDepartmentForm
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
          onCancel();
        }}
        onCancel={onCancel}
        stores={stores}
      />
    </Modal>
  );
};

export default StoreDepartmentModal;
